import { createFileRoute } from '@tanstack/react-router';
import { SmartWorkingFlow } from '@/features/smart-working/SmartWorkingFlow';

export const Route = createFileRoute('/_app/smart-working')({ component: SmartWorkingFlow });
